import { ReduceStore } from 'flux/utils';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';

class CurrentUserIdStore extends ReduceStore {
  getInitialState() {
    return null;
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.Admin.CURRENT_USER_LOADED:
        return action.user.id;
      default:
        return state;
    }
  }
}

const instance = new CurrentUserIdStore(AppDispatcher);
export default instance;
